import { Hero } from '@/components/imprint/Hero';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { config } from '@/pageConfig/imprint/de/de';

export default function ImprintPage() {
  return (
    <Layout headerActions={config.layout.headerActions} pt={[90, 60, 100]}>
      <SEO {...config.seo} />
      <PageWrapper>
        <Hero {...config.hero} />
      </PageWrapper>
    </Layout>
  );
}
